export const createCircle = (color: string) => {
  const circle = document.createElement('div');
  circle.style.backgroundColor = color;
  circle.style.width = '10px';
  circle.style.height = '10px';
  circle.style.borderRadius = '50%';
  circle.style.display = 'inline-block';
  circle.style.marginRight = '-2px';
  circle.style.border = '1px solid white';
  return circle;
};
